import { useCallback, useEffect, useState } from 'react';
import { Logger } from '../../../utils';
import { useFacebookConnection } from '../contexts/facebookConnectionContext';
import { useStepstoneFacebookLoginApi, } from './useStepstoneFacebookLoginApi';
export const useLoginWithFacebook = () => {
    const { login: loginToFacebook, status: facebookConnectionStatus, authData: { accessToken, userId }, } = useFacebookConnection();
    const { login: loginToStepstone, status: stepstoneLoginStatus, accountWasCreated, email, hasCompleteCv, failureReason: stepstoneLoginFailureReason, } = useStepstoneFacebookLoginApi();
    const [status, setStatus] = useState('awaitingConsent');
    const [failureReason, setFailureReason] = useState(null);
    const [loginAttemptInitiated, setLoginAttemptInitiated] = useState(false);
    const [loginToFacebookFailed, setLoginToFacebookFailed] = useState(false);
    const [consent, setConsent] = useState({
        thirdPartyMarketingContentEmail: false,
    });
    useEffect(() => {
        Logger.info('FacebookConnectionStatus: %s', facebookConnectionStatus);
        if (facebookConnectionStatus === 'awaitingConsent' ||
            facebookConnectionStatus === 'initialising' ||
            facebookConnectionStatus === 'initialisationFailed') {
            setStatus(facebookConnectionStatus);
        }
        else if (facebookConnectionStatus === 'loading' ||
            stepstoneLoginStatus === 'loading') {
            setStatus('loading');
        }
        else if (stepstoneLoginStatus === 'error') {
            setStatus('error');
            setFailureReason(stepstoneLoginFailureReason);
        }
        else if (loginToFacebookFailed) {
            setStatus('error');
            setFailureReason('loginToFacebookFailed');
        }
        else if (stepstoneLoginStatus === 'success') {
            setStatus('success');
        }
        else {
            setStatus('idle');
        }
    }, [
        facebookConnectionStatus,
        stepstoneLoginStatus,
        stepstoneLoginFailureReason,
        loginToFacebookFailed,
    ]);
    useEffect(() => {
        if (!loginAttemptInitiated || facebookConnectionStatus === 'loading')
            return;
        if (facebookConnectionStatus === 'connected') {
            loginToStepstone({ userId, accessToken }, consent);
        }
        else {
            setLoginToFacebookFailed(true);
        }
        setLoginAttemptInitiated(false);
    }, [
        loginAttemptInitiated,
        facebookConnectionStatus,
        loginToStepstone,
        userId,
        accessToken,
        consent,
    ]);
    const login = useCallback((consentSetting) => {
        if (facebookConnectionStatus === 'awaitingConsent' ||
            facebookConnectionStatus === 'loading' ||
            facebookConnectionStatus === 'initialising' ||
            facebookConnectionStatus === 'initialisationFailed')
            return;
        setConsent(consentSetting);
        setLoginToFacebookFailed(false);
        setLoginAttemptInitiated(true);
        if (facebookConnectionStatus !== 'connected') {
            loginToFacebook();
        }
    }, [facebookConnectionStatus, loginToFacebook]);
    return {
        login,
        status,
        accountWasCreated,
        email,
        hasCompleteCv,
        failureReason,
    };
};
//# sourceMappingURL=useLoginWithFacebook.js.map